import {motion} from "framer-motion";
import {ChevronRight} from "lucide-react";
import React from "react";
import {useNavigate} from "react-router-dom";


const HomeQuickAction = ({icon: Icon, title, description, link}) => {
    const navigate = useNavigate();
    const handleClick = (link) => {
        navigate(link,);
    }

        return (
            <motion.div
                whileHover={{y: -5, boxShadow: "0 10px 30px -15px rgba(0, 0, 0, 0.1)"}}
                transition={{duration: 0.2}}
                className="bg-white rounded-lg shadow-sm p-6 group cursor-pointer"
                onClick={() => handleClick(link)}
            >
                <div className="flex items-center mb-4">
                    <div
                        className="p-3 bg-indigo-100 rounded-full mr-4 group-hover:bg-indigo-200 transition-colors duration-300">
                        <Icon className="h-6 w-6 text-indigo-600"/>
                    </div>
                    <h4 className="text-lg font-semibold text-gray-800 group-hover:text-indigo-600 transition-colors duration-300">{title}</h4>
                </div>
                <p className="text-gray-600">{description}</p>
                <motion.div
                    className="mt-4 flex items-center text-indigo-600 font-medium"
                    initial={{x: 0}}
                    whileHover={{x: 5}}
                >
                    Get Started <ChevronRight className="h-4 w-4 ml-1"/>
                </motion.div>
            </motion.div>
        );

}

export default HomeQuickAction;
